import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const VehicleDetailsPageWrapper = styled.div`
  width: 100%;
  margin: 0;
  @media ${device.tablet} {
    width: calc(100% - 120px);
    margin: 0 auto 96px auto;
  }
  @media ${device.laptopL} {
    width: calc(100% - 192px);
    margin: 0 auto 96px auto;
  }
  @media ${device.desktop} {
    max-width: 1248px;
    margin: 0 auto 96px auto;
  }
`;

export const Wrapper = styled(VehicleDetailsPageWrapper)<{ backgroundColor?: string }>`
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : COLORS.audiGrayFive)};
  @media ${device.tablet} {
    background: transparent;
  }
`;

export const Tier3Wrapper = styled.div`
  margin: 0;
  margin-right: 18px;
  margin-left: 18px;
  @media ${device.tablet} {
    width: calc(100% - 120px);
    margin: 0 auto 96px auto;
  }
  @media ${device.laptopL} {
    width: calc(100% - 192px);
    margin: 0 auto 96px auto;
  }
  @media ${device.desktop} {
    max-width: 1248px;
    margin: 0 auto 96px auto;
  }
`;

export const SectionTitle = styled.h2<{ displayOnMobile?: boolean }>`
  display: ${(props) => (props.displayOnMobile ? '' : 'none')};
  font-family: 'Audi Type Extended';
  font-size: 24px;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 36px;
  @media ${device.tablet} {
    display: block;
    margin-bottom: 32px;
  }
  @media ${device.laptop} {
    font-size: 32px;
    line-height: 48px;
  }
  @media ${device.laptopL} {
    font-size: 40px;
  }
`;

export const Container = styled.div`
  width: 100%;
  position: relative;
  .react-loading-skeleton {
    height: 1058px;
  }
  @media ${device.tablet} {
    .react-loading-skeleton {
      height: 896px;
    }
  }
  @media ${device.laptop} {
    .react-loading-skeleton {
      height: 1116px;
    }
  }
`;
